import { useMemo } from 'react';
import { generatePath, useParams } from 'react-router';
import { EmojiEvents } from '@mui/icons-material';

import HeaderNavigation from '@/components/navigation/HeaderNavigation';
import ContentDetail from '@/components/routes/ContentDetail';
import useLearningRoutes from '@/context/routes/hook';
import { routes } from '@/constants/routes';
import theme from '@/constants/theme';
import useUser from '@/hooks/useUser';

import useLoadContent from './useLoadContent';
import ContentCover from '@/components/routes/ContentCover';

const Content = () => {
  const { routeId, contentId } = useParams();
  const { loading, content, isStageContent, stageId } = useLoadContent({ routeId, contentId });

  const { user } = useUser();
  const { getRouteById } = useLearningRoutes();

  const userRouteProgressId = useMemo(
    () => getRouteById(routeId as string)?.userRouteProgressId,
    [getRouteById, routeId],
  );

  if (!contentId) return null;

  return (
    <div
      style={{
        flex: 1,
        backgroundColor: theme.colors.background.primary,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        maxHeight: '100%',
      }}
    >
      <HeaderNavigation
        loading={loading}
        title={content?.title!}
        backHref={generatePath(routes.routes.detail, { routeId })}
        rightContent={
          <p
            style={{
              color: theme.colors.primary,
              fontSize: 16,
              display: 'flex',
              gap: 4,
              alignItems: 'center',
            }}
          >
            {user?.points ?? 0}
            <EmojiEvents />
          </p>
        }
      />
      {!content?.completed && !content?.contentInteractionId ? (
        <ContentCover
          routeId={routeId}
          contentId={contentId}
          userRouteProgressId={userRouteProgressId}
          title={content?.title}
          duration={content?.duration}
          type={content?.type}
          stageId={stageId}
          overviewData={content?.overviewData}
          loading={loading}
        />
      ) : (
        <ContentDetail
          routeId={routeId}
          content={content}
          userRouteProgressId={userRouteProgressId}
          isStageContent={isStageContent}
          loading={loading}
        />
      )}
    </div>
  );
};

export default Content;
